import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Alert from '@react/react-spectrum/Alert';
import Button from '@react/react-spectrum/Button';
import { Card, CardCoverPhoto, CardBody } from '@react/react-spectrum/Card';
import Heading from '@react/react-spectrum/Heading';
import Wait from '@react/react-spectrum/Wait';

import { RootContext } from '../../root/RootContext';
import { useMyThirdPartyProducts } from '../../data/hooks';
import { useSidebar } from '../App';
import ThirdPartyProductSidebar from '../../fragments/sidebars/ThirdPartyProductSidebar';
import { PATHS, ENVIRONMENT_TYPES } from '../../config/constants';

export default function ThirdPartyProducts() {
  const history = useHistory();
  const { state, dispatch } = useContext(RootContext);
  const { show: showSidebar } = useSidebar();
  const { loading, error, data, refetch } = useMyThirdPartyProducts();

  if (state.fetchThirdPartyProducts) {
    refetch();
    state.fetchThirdPartyProducts = false;
  }

  if (loading) {
    return (
      <div className="wait-wrapper">
        <Wait size="S" /> Loading third-party products...
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-wrapper">
        <Alert variant="error" header="Error">
          {error.message}
        </Alert>
      </div>
    );
  }

  const { myThirdPartyProducts } = data;

  const getImage = (type) => {
    return ENVIRONMENT_TYPES.thirdParty.find((e) => e.name === type)?.image;
  };

  const selectThirdPartyProduct = (product) => (e) => {
    dispatch({
      type: 'thirdPartyProducts/SET_ACTIVE',
      thirdPartyProduct: product
    });
    showSidebar(<ThirdPartyProductSidebar />);
  };

  return (
    <div className="third-party-products">
      <div>
        <Heading variant="pageTitle">Third-party products</Heading>
        <Button
          className="add-environment"
          variant="secondary"
          onClick={() => history.push(PATHS.ADD_PRODUCT)}>
          Add environment
        </Button>
      </div>

      <div>
        {Array.isArray(myThirdPartyProducts) &&
        myThirdPartyProducts.length > 0 ? (
          myThirdPartyProducts.map((environment) => (
            <Card
              key={environment.name}
              allowsSelection={false}
              onClick={selectThirdPartyProduct(environment)}>
              <CardCoverPhoto src={getImage(environment.type)} />
              <CardBody title={environment.name} subtitle={environment.type} />
            </Card>
          ))
        ) : (
          <div>You don't have any third-party products registered.</div>
        )}
      </div>
    </div>
  );
}
